import Reflux               from 'reflux';
import ChoiceActionsFactory from './choices/choice-actions-factory';
const StoreCache = {}

export default class SubmitButtonStore extends Reflux.Store {
  constructor(props) {
    super();
    props.questions.forEach( (question) => {
      const choiceActions = ChoiceActionsFactory.get(question.questionId)
      this.listenTo(choiceActions.change, this.onChange);
    })
    this.props = props;
    this.state = this.getInitialState();
    this.state.isDisabled = this.isDisabled();
  }
  getInitialState() {
    return {
      isDisabled: false
    }
  }
  isDisabled() {
    let requiredQuestions = this.getRequiredQuestions()
    let requiredResponses = this.getResponses(requiredQuestions);
    let responses = this.getResponses(this.props.questions);
    return responses.length==0 || requiredResponses.length<requiredQuestions.length;
  }
  getRequiredQuestions() {
    return this.props.questions.filter( (question) => {
      return question.required;
    })
  }
  getResponses(questions=[]){
    let responseList =[];
    return questions.filter( (question) => {
      let choices = question.choices;
      if(question.displayType==5 || question.displayType==4 || choices==null || choices.length==0){
          let responseText = question.responseText;
          return responseText!=null && responseText.length>0;
      }

      let choice = choices.find((choice)=>{
          return choice.selected;
      });
      return (choice!=null);
    })
  }
  onChange() {
    this.setState({
        isDisabled: this.isDisabled()
    })
  }
}

SubmitButtonStore.get = function(questionnaire) {
  const qid = questionnaire.qid;
  const formId = questionnaire.formId;
  const key = `qid[${qid}]-for[-${formId}]`;
  if(StoreCache[key]==null || StoreCache[key].listenables==null || StoreCache[key].listenables.length==0 || StoreCache[key].listenables.length==null ){
    StoreCache[key]=new SubmitButtonStore(questionnaire);
  } else {
    StoreCache[key];
  }
  return StoreCache[key];
}



// WEBPACK FOOTER //
// ./medscape_modules/qna/form-components/submit-button-store.js